if (!customElements.get('mobile-pdp-header')) {
  customElements.define('mobile-pdp-header', class MobilePdpHeader extends HTMLElement {
    connectedCallback() {
      this.trigger = this.querySelector('[data-pdp-search-trigger]');
      this.panel = this.querySelector('[data-pdp-search-panel]');
      if (!this.trigger || !this.panel) return;

      this.mobile = window.matchMedia('(max-width: 767px)');
      this.controller = new AbortController();
      const { signal } = this.controller;
      this.trigger.addEventListener('click', () => this.toggleSearch(), { signal });
      this.querySelector('[data-pdp-search-close]').addEventListener('click', () => this.closeSearch(true), { signal });
      this.addEventListener('keydown', (event) => {
        if (event.key === 'Escape' && this.hasAttribute('search-open')) {
          event.preventDefault();
          this.closeSearch(true);
        }
      }, { signal });
      document.addEventListener('pointerdown', (event) => {
        if (!this.contains(event.target)) this.closeSearch(false);
      }, { signal });
      this.mobile.addEventListener('change', () => this.closeSearch(false), { signal });
      this.setAttribute('data-ready', '');
    }

    disconnectedCallback() {
      this.controller?.abort();
      this.removeAttribute('data-ready');
    }

    toggleSearch() {
      if (this.hasAttribute('search-open')) return this.closeSearch(true);
      this.setAttribute('search-open', '');
      this.trigger.setAttribute('aria-expanded', 'true');
      this.panel.querySelector('input[type="search"]')?.focus();
      this.updateHeaderHeight();
    }

    closeSearch(restoreFocus) {
      if (!this.hasAttribute('search-open')) return;
      this.panel.querySelector('predictive-search')?.close?.();
      this.removeAttribute('search-open');
      this.trigger.setAttribute('aria-expanded', 'false');
      if (restoreFocus && this.mobile.matches) this.trigger.focus();
      this.updateHeaderHeight();
    }

    updateHeaderHeight() {
      this.closest('sticky-header')?.setHeaderHeight?.();
    }
  });
}
